import React from "react";

import Title from "../../../components/Title";
import Spacer from "../../../components/Spacer";
import Button from "../../../components/Field/Button";
import Background from "../../../components/Background";

import style from "./style.module.css";

export default function Card({ item }) {
    const offerText = item.book_offer_text !== undefined ? item.book_offer_text : "";
    return (
        <>
            {
                item.book.length > 0 && (
                    <div className={`${style.card} ${style.col3}`}>
                        <div className={style.cardInner}>
                            {
                                item.book.map((bookItem, index) => {
                                    return (
                                        <div className={style.cardInnerHelper} key={`bookItem_${index}`}>
                                            <Background src={bookItem.thumbnail_image} size="450x265" cPosition="topRight" />
                                            <div className={style.cardRow}>
                                                <div className={style.imageContent}>
                                                    <div className={style.imageWrap}></div>
                                                    <Background src={bookItem.image} size="140x215" cPosition="bottomLeft" />
                                                    <div className={`${style.offerText} ${offerText !== "" ? style.textYes : style.textNo}`}>
                                                        {offerText}
                                                    </div>
                                                </div>
                                                {
                                                    bookItem.name !== "" && bookItem.url !== "" && (
                                                        <div className={style.textContent}>
                                                            <>
                                                                <Title transform="uppercase" tag="h4" className="fontTeko">{bookItem.name}</Title>
                                                                <Spacer size={16} />
                                                                <Button
                                                                    size="buttonSmall"
                                                                    color="buttonPrimary"
                                                                    link={`/book/${bookItem.url}`}
                                                                    label="SHOP NOW"
                                                                />
                                                            </>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                )
            }
        </>
    )
}